module.exports = __webpack_public_path__ + "media/images/diamond-63bf79c9e3df7b00b010069fdf288172.svg";